module.exports = __webpack_public_path__ + "img/join.7737871c.png";